module.exports = __webpack_public_path__ + "img/img4.dc49704a.jpg";